import React from 'react'
import { Navigate, useLocation } from 'react-router-dom'

interface ProtectedRouteProps {
  children: React.ReactNode
}

const ProtectedRoute: React.FC<ProtectedRouteProps> = ({ children }) => {
  const location = useLocation()
  // 兼容两套登录：主系统 token 或 面板 panel_token，任一存在即可访问
  const token = localStorage.getItem('token') || localStorage.getItem('panel_token')

  console.log('ProtectedRoute检查:', {
    hasToken: !!token,
    tokenLength: token?.length || 0,
    currentPath: location.pathname,
    token: token ? `${token.substring(0, 20)}...` : 'null'
  })

  if (!token) {
    console.log('ProtectedRoute: 未找到token，重定向到登录页面')
    return <Navigate to="/login" state={{ from: location }} replace />
  }

  console.log('ProtectedRoute: token存在，允许访问')
  return <>{children}</>
}

export default ProtectedRoute







